export default __webpack_public_path__ + "static/mob-img-8dd51a08c37e18f76b5d2d4c46501b54.png";